// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".entity_decision_list-module__link--28520{font-weight:400;font-size:16px;line-height:24px;letter-spacing:0px;cursor:pointer;display:block;margin-top:24px;margin-bottom:24px}.entity_decision_list-module__link--28520:hover{text-decoration:underline}\n", ""]);
// Exports
exports.locals = {
	"link": "entity_decision_list-module__link--28520"
};
module.exports = exports;
